const appUrl = process.env.REACT_APP_OPX_API_URL;
export const apiUrl = appUrl;

// const appUrl = "http://localhost:3008";
export const ApiConfig = {
  // =========EndPoints==========
  login: "login",
  newPassword: "forgot_password",
  get_downline: "get_downline",
  sendOtp: "send-otp",
  addTrader: "add-trader",
  placeTrade: "place-trade",
  tradesByAdmin: "trades-by-admin",
  deleteTrade: "delete-trade",
  getdata: "pending-kyc-user",
  cpbalancebycoin: "cpbalancebycoin",
  getverifyData: "approve-kyc-user",
  getrejectedData: "rejected-kyc-user",
  getkycData: "kyc-details",
  verifyIdentity: "update-kyc-status",
  rejectIdentity: "verify-kyc",
  getusers: "getUsers",
  getDetails: 'profile',
  getTotaluser: "user-count",
  getVerified: "approved-kyc-count",
  getPending: "pending-kyc-count",
  getSupport: "support",
  getwithdrawal: "withdrawlrequest",
  getregistration: "counnewreg",
  allkyc: "kyc-details",
  coinlist: "coinList",
  currencyPair: "allsinglecoinlist",
  getSubAdminList: "sub-admin-list",
  getPartnersList: "getpartnerships",
  getPackageList: "bot-package-listing",
  getFundList: "get-investment",
  getUserPackageList: "get-active-package",
  getCoinListDetails: "getcoinListedDetails ",
  AddsubAdmin: "add-new-admin",
  AddTrade: "addnewtrader",
  qbshistory: "qbshistory",
  subadmindelete: "delete_subadmin",
  getallorder: "getOrders",
  addNotify: "add_notification",
  deleteNotify: "delete",
  notificationList: "admin-listing",
  helplist: "getallhelplist",
  todayNewRegistrations: "today_new_registration",
  createCategory: "create-coin-category",
  SubadminStatus: "admin_status",
  PartnersStatus: "update-partner-status",
  packageStatus: "update-bot-package-status",
  OpenOrderStatus: "delete-single-open-order",
  CoinDetailsStatus: "setcoindetailstatus ",
  updateSubadmin: "edit_subadmin",
  tradeStatus: "kycsetstatus",
  getInrWithrawList: "withdraw_request",
  get_inr_deposit_pending: "get_inr_deposit_pending",
  userreqapprove: "confirmInrWithdraw",
  userreqreject: "rejectInrWithdraw",
  addAdTicket: "addAdTicket",
  ticketList: "ticketlist",
  adminsupport: "adminsupport",
  sendmailtouser: "sendmailtouser",
  documentchange: "documentchange",
  transferhistory: "user-trade-history",
  userWallet: "user-wallet",
  admintransfer: "admintransfer",
  depositrequest: "depositrequest",
  withdrawlrequest: "withdrawlrequest",
  totaldepositrequest: "depositrequest",
  totalwithdrawlrequest: "getWithdrawlReq",
  getmasterbal: "getmasterbal",
  changeseen: "changeseen",
  currencyCoinList: "get-coin",
  userBank: "user-bank",
  walletCoinList: "adminwallet",
  setcoinwithdrawal: "edit-currency",
  getcpaccountinfo: "getcpaccountinfo",
  getcpcoinbalance: "getcpcoinbalance",
  AddCoinPair: "add-pairs",
  AddPairFee: "updatecoinfee",
  getCurrencyPairList: "get-pairs",
  tredingReport: "trading-commission",
  sendFundStatus: "transactionstatus",
  completeWithdrawalRequest: "complete_withdrawal_request",
  PendingWithdrwal: "pending_withdrawal_request",
  CancelledWithdrwal: "reject_withdrawal_request",
  completeDepositRequest: "complete_deposit_request",
  cancelled_deposit_request: "cancelled_deposit_request",
  updateDepositRequest: "update-deposit-request",
  cvbot_complete_deposit_request: "cvbot_complete_deposit_request",
  completePendingRequest: "pending_deposit_request", // INR
  SIPPendingRequests: "sip_pending_requests",
  updateSIPDepositRequest: "update-sip-deposit-request",
  inrdepositreq: "deposit_request",
  completeDetailsUser: "complete-details-user",
  // confirmInrDeposit: "update_deposit_status",
  // rejectInrDeposit: "update_deposit_status",
  getUserWalletList: "select_given_coin",
  userWalletTransfer: "withdrawalcoin",
  // setrewardrate: "kyc/setrewardrate",
  // updatetdsrate: "updatetdsrate",
  updatemailTamplate: "updatemailTamplate",
  tradersList: "user-list",
  affiliateInvestmentList: "affiliate-investment-list",
  stats: "stats",
  pendingtrader: "pendingtrader",
  fiatwithreq: "fiatwithreq",
  verifiedtrader: "verifiedtrader",
  fiatdepreq: "fiatdepreq",
  addNewCoins: "add-coin",
  getMasterWalletList: "adminwallettransactions",
  admincoinaddress: "admincoinaddress",
  getreceive: "getreceive",
  stakingList: "stacking/getAllUserstacking",
  transactionstatus: "update_withdrawal_status",
  Addbanner: "add_banner",

  bannerList: "banner_list",
  updateBanner: "update_banner",
  bannerdelete: "delete-banner/",
  packageDelete: "delete-bot-package/",
  BannerStatus: "set_banner_status",
  deleteCoinPair: "delete-pair",
  walletStatus: "withdrawstatus",
  getOtp: "auth/getcode",
  walletTransfer: "/transfertoother",
  addBankAcc: "add_bank_details",
  getAccDetails: "get_user_bank_details",
  fundsTransfer: "debit_credit",
  debit_credit_transaction: "debit_credit_transaction",
  getCoinList: "get-coin",
  CoinCategory: "coin-category-list",
  tradingCommission: "trading-commission",
  tradeHistory: 'trade-history',
  OrderBook: 'orderbook',
  withdrawalFees: 'withdrawal_fees',
  OpenOrders: 'all-open-orders',
  updateStatus: 'update_status',
  tradeById: 'find-trades-by-orderid',
  miscellaneousRequest: 'miscellaneous_withdrawal_request',
  MasterAccount: 'master-account',
  botStatus: 'bot-status',
  cancelOrder: 'cancel-order',
  verifyBankDetails: "verify-bank-details",
  pendingBankDetails: "pending-bank-details",
  approveBankDetails: "approve-bank-details",
  rejectBankDetails: "reject-bank-details",
  getLoginOtp: "send-otp",
  getMyLogs: "get_logs",
  getFiatAccounts: "admin-bank",
  updateFiatAccounts: "update-admin-bank",
  deleteFiatAccount: "delete-admin-bank",
  updateAllowedFiat: "updateAllowedFiat",
  mapReferral: "map-referral",
  UnmapReferral: "unmawp-referral",
  user_walletdd: "all-user-wallet-backup",
  fund_transfer: "fund-transfer",
  updateTicketStatus: "update-ticket-status",
  getAllTickets: 'get-all-tickets',
  replyTicket: "reply-ticket",
  orderDetails: 'order_details',
  orderDispute: 'dispute_handling',
  p2pCoinList: "p2p_coin_list",
  fiatCurrencyList: "fiat_currency_list",
  all_p2p_orders: "all_p2p_orders",
  add_fiat: "add_fiat",
  remove_currency: "remove_currency",
  pendingUPIDetails: "pending-upi-details",
  approveUPIDetails: "approve-upi-details",
  rejectUPIDetails: "reject-upi-details",
  verifyUPIDetails: "verify-upi-details",
  statusToSettle: "statusToSettle",
  AddNewCoin: "create-package",
  getCoinPackageList: "pending-coin-listing-request",
  ApprovedCoinList: "approved-coin-listing-request",
  RejectCoinList: "rejected-coin-listing-request",
  coinStatus: "update-coin-status",
  blogList: "blog-list",
  blogStatus: "blog-status",
  deleteBlog: "delete-blog",
  addBlog: "add-blog",
  updateBlog: "update-blog",
  userFind: "find-user",
  // Notification
  singalUser: "single-user",
  sendBulkNotification: "send-bulk",
  sendToAll: "send-all",
  updateNotificationStatus: "update-status",
  updateBankStatus: "update-bank-status",
  announcementBanner: "add-banner",
  getBannerList: "admin-banner-listing",
  updateBannerStatus: "update-status",
  bannerDelete: "delete-banner",
  updateAnnouncement: "add-personal-announcement",
  getAnnouncementList: "all-personal-announcement",
  announcementStatus: "personal-announcement-status",
  deleteAnnouncement: "delete-personal-announcement",
  getPayments: "get-payments",
  rejectSIPInstallment: "reject-sip-installment",
  generateAgreement: "generate-contract-pdf",
  saveEditedAgreement: "save-edited-agreement",
  updatePlaceholders: "update-placeholders",
  updateAgreementStatus: "update-status",
  fipWithdrawal: "fip-withdrawal",
  getFIPWithdrawalList: "fip-withdrawal-list",





  // Admin Wallet balance
  getbalanceNativeBNB: "getbalanceNativeBNB",
  TronNativeBalance: "TronNativeBalance",
  getbalanceNativeETH: "getbalanceNativeETH",




  // arbitrage Bot
  createBotPackage: "create-bot-package",
  ReferralList: "bot-referral-listing",
  botTrades: "bot-trades",
  deleteBotTrades: "delete-bot-trade",
  addBotTrade: "add-bot-trade",
  buyArbitrageBot: "buy-arbitrage-bot",

  // Earning module
  userSubscriptions: "user-subscriptions",
  distributePayout: "distribute-payout",
  addPackage: "add-package",
  createInvestor: "create-investor",
  updatePackageStatus: "update-package-status",
  updateInvestorStatus: "update-investor-status",
  updateInvestorRoi: "update-investor-roi",
  deletePackage: "delete-package",
  editPackage: "edit-package",
  payoutList: "payout-list",
  payoutHistory: "admin-payout-history",
  userpayoutHistory: "payout-history",
  allPackageList: "all-package-list",
  updateUserType: "update-user-type",
  // Affiliate
  uplines: "uplines",
  investment: "investment",
  getROIForDistribution: "getROIForDistribution",
  editinvestment: "editinvestment",
  updateinvestment: "update-investment",
  updateinvestmentroi: "update-investment-roi",
  updateinvestmentAmount: "update-investment-amount",
  updateallinvestmentroi: "update-all-investment-roi",
  updateStatusAffiliate: "update-status",
  updateStatusWithRelease: "update-status-with-release",
  getWalletBalance: "get-wallet-balance",
  loadInvestments: "list",
  getSIPRequests: "get-sip-request",
  approveAffiliateInvestment: "approve-affiliate-investment",
  rejectSIPRequest: "reject-affiliate-investment",
  sipInstallmentPayment: "installment-payment",
  sipUpdateInstallments: "update-installments",
  sipChangeInstallmentDate: "change-installment-date",
  getBlogCategories: "blog-category-list",
  addBlogCategory: "add-blog-category",
  updateBlogCategory: "update-blog-category",
  deleteBlogCategory: "delete-blog-category",



  // P2P Management APIs
  p2pCreateFiat: "p2p/fiat-currencies",
  p2pUpdateFiat: "p2p/fiat-currencies",
  p2pUpdateFiatStatus: "p2p/fiat-currencies",
  p2pDeleteFiat: "p2p/fiat-currencies",
  p2pFiatList: "fiat_currency_list",
  p2pAdsList: "p2p/ads",
  p2pAdDetails: "p2p/ads",
  p2pOrdersList: "p2p/orders",
  p2pOrderDetails: "p2p/orders",
  p2pUserPaymentMethods: "p2p/users",
  p2pDisputesList: "p2p/disputes",
  p2pDisputeDetails: "p2p/disputes",
  p2pResolveDispute: "p2p/disputes",
  p2pSendEmail: "p2p/send-email",

  // ============URLs================
  baseEarning: `${appUrl}/v1/earning/`,
  baseHelp: `${appUrl}/help/`,
  baseAffiliate: `${appUrl}/v1/affiliate/`,
  baseTran: `${appUrl}/v1/transaction/`,
  baseUrl: `${appUrl}/v1/admin/`,
  uploadUrl: `${appUrl}/uploads/`,
  basenotify: `${appUrl}/acc/`,
  baseSecure: `${appUrl}/v1/coin/`,
  baseWallet: `${appUrl}/v1/wallet/`,
  baseCoin: `${appUrl}/v1/coins/`,
  baseReport: `${appUrl}/report/`,
  baseExchange: `${appUrl}/v1/exchange/`,
  baseBalance: `${appUrl}/v1/balance/`,
  baseAdmin: `${appUrl}/v1/admin/`,
  baseUser: `${appUrl}/v1/user/`,
  baseSupport: `${appUrl}/v1/support/`,
  baseP2P: `${appUrl}/v1/p2p/`,
  basePartner: `${appUrl}/v1/partnerShip/`,
  uploadcurrency: `${appUrl}/`,
  appUrl: `${appUrl}/`,
  baseSecureCoin: `${appUrl}/v1/coin_test/`,
  baseCoins: `${appUrl}/v1/coins/`,
  baseNotification: `${appUrl}/v1/notifications/`,
  baseBanner: `${appUrl}/v1/banners/`,
  baseBot: `${appUrl}/v1/bot/`,
  baseAgreement: `${appUrl}/v1/document/`,

};
